import {ConnectedComponent} from 'lowkey-component'
import {MediaQuery} from '@services/MediaQuery'
import {WindowService} from '@services/WindowService'
import {appSelectors} from '@store/appSlice'

export class WindowHeight extends ConnectedComponent {
  private window = WindowService.create()
  private mq = MediaQuery.create()

  didMount() {

    this.window.onResize.connect(this.onResizeWindow)

    this.observe(appSelectors.selectOrientation, this.changeOrientation)

    this.resize()
  }

  didUnmount() {
    this.window.onResize.disconnect(this.onResizeWindow)
  }

  onResizeWindow = () => {
    if (this.mq.isDesktop()) {
      this.resize()
    }
  }

  resize() {
    const height = window.innerHeight
    this.element.style.height = `${height}px`
  }

  changeOrientation = () => {
    if (this.mq.isPhone()) {
      this.resize()
    }
  }
}
